import React, { Component } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import moment from 'moment';
import Frame from './Frame';
import IFrame from './IFrame';
import loader from '../../src/components/css/dark/img/loader.gif';
if (window.location.host.split('.').slice(-2).join('.').toLowerCase() == "rxhacker.com" || window.location.host.split('.').slice(-2).join('.').toLowerCase() == "localhost:5464" || window.location.host.toLowerCase() == "tempfilter-dev.glichealth.com" || window.location.host.toLowerCase() == "reporting.nulifespanrx.com") {
    import("./css/dark/rxhacker.css")
} else {
    import("./css/dark/main.css")
}
const { AbortController } = window;

class Chart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
            chartData: [
            ],
            options: {
                maintainAspectRatio: false,
                responsive: true
            },
            IsDataLoaded: false,
            XlabelString: this.props.XlabelString,
            YlabelString: this.props.YlabelString,
            IFrameId: this.props._Index
        };
        this.abortController = null;
        this.debounceTimer = null;
    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Line") {
            this.fetchData_locally();
        }

    }
    componentDidMount() {
        if (this.props.data.type == "Line") {
            this.fetchData_locally();
        }
        window.Chart.defaults.global.defaultFontFamily = 'Apercu-Regular';
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }
    fetchData_locally() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        this.setState({
            IsDataLoaded: false
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                //--------------------------------Line Chart Data Handling Start Here-------------------------
                try {
                    //var topLabel = apidata[0].toplabel,
                    this.setState({
                        ...this.state,
                        IsDataLoaded: true,
                        chartData: [
                            {
                                //labels: tempArr,
                                datasets: [
                                    {
                                        label: apidata[0].lineDataSet[0].toplabel,
                                        data: apidata[0].lineDataSet[0].datasets,
                                        backgroundColor: '#fff',
                                        borderColor: '#26d07c',
                                        pointBackgroundColor: '#fff',
                                        pointBorderColor: '#26d07c',
                                        pointBorderWidth: 2,
                                        fill: false
                                    }
                                ]
                            }
                        ],
                        options:
                        {
                            tooltips: {
                                backgroundColor: '#fff',
                                titleFontColor: '#8ba6c1',
                                borderWidth: 1,
                                borderColor: '#dde5ed',
                                titleFontFamily: 'Apercu-Regular',
                                titleFontSize: 12,
                                bodyFontFamily: 'Apercu-Regular',
                                bodyFontSize: 16,
                                bodyFontColor: '#1d252d',
                                xPadding: 10,
                                titleFontStyle: "normal",
                                bodyFontStyle: 600,
                                tooltipFontFamily: 'Apercu-Regular'
                            },
                            maintainAspectRatio: true,


                            scales: {
                                yAxes: [{
                                    ticks: {
                                        display: true,
                                        fontColor: "#8ba6c1",
                                        fontSize: 14
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.state.YlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#8ba6c1',
                                        fontSize: 14
                                    },
                                    gridLines: {
                                        //offsetGridLines: true
                                        drawBorder: false
                                    },
                                }],
                                xAxes: [{
                                    type: 'time',
                                    offset: true,
                                    time: {
                                        unit: 'day',
                                        barPercentage: 0,
                                        barThickness: 0,
                                        maxBarThickness: 0,
                                        minBarLength: 0,
                                        gridLines: {
                                            //offsetGridLines: true
                                            lineWidth: 0,
                                            display: false,
                                            drawBorder: false
                                        }
                                    },
                                    ticks: {
                                        fontColor: "#8ba6c1",
                                        fontSize: 14
                                    },
                                    gridLines: {
                                        //offsetGridLines: true
                                        lineWidth: 0,
                                        display: false,
                                        drawBorder: false
                                    },
                                    scaleLabel: {
                                        display: true,
                                        labelString: this.state.XlabelString,
                                        fontFamily: 'Apercu-Regular',
                                        fontColor: '#8ba6c1',
                                        fontSize: 14
                                    }
                                }]
                            },
                            legend: {
                                labels: {
                                    // This more specific font property overrides the global property
                                    fontColor: '#8ba6c1'
                                },
                                display: false
                            },
                        }
                    });
                }
                catch (error) {
                }
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true,
                    noDataDisplay: 'Error while loading data'
                });
            });
    }
    handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            return data;
        });
    }

    render() {
        return (
            <div>
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
            <Frame id={this.state.IFrameId} scrolling="no" key={"graph-frame" + this.state.IFrameId}>
                <div className="myChart">
                    {this.state.chartData != null ? this.state.chartData.map((item, index) => {
                        return <Line data={item} options={this.state.options} key={index} />
                    }) : null }
                </div>
                </Frame>
          </div>
        )

    }


}
export default Chart;